<template>
  <div class="psReports view">
    <ps-page-container :site="{ site: 'Reportes' }"></ps-page-container>
  </div>
</template>

<script>
import PsPageContainer from '@/components/layout/PsPageContainer.vue'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'PsReports',
  components: { PsPageContainer },
  computed: {
    ...mapState(['isMobile'])
  },
  methods: {},

}
</script>

<style scoped>

</style>